import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["active", "block", "buttonProps", "children", "completed", "closable", "disabled", "onClear", "onClick", "size", "theme", "invalid", "namespace", "classes", "isSorting", "selected", "sortingTitle"];
import React, { forwardRef } from 'react';
import classNames from 'classnames/bind';
import { defaultPropObject } from "../constants";
import { ChevronNormalDown, CloseSmallLinear } from "../icons";
import { TextBase } from "../internal/TextBase";
import { getMethodsForTestId } from "../utils/getMethodsForTestId";
import styles from './FilterButton.css';
var cx = classNames.bind(styles);
var FilterButton = /*#__PURE__*/forwardRef(function FilterButton(_ref, ref) {
  var _cx;

  var active = _ref.active,
      block = _ref.block,
      buttonProps = _ref.buttonProps,
      children = _ref.children,
      completed = _ref.completed,
      _ref$closable = _ref.closable,
      closable = _ref$closable === void 0 ? true : _ref$closable,
      disabled = _ref.disabled,
      onClear = _ref.onClear,
      onClick = _ref.onClick,
      size = _ref.size,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'b2c' : _ref$theme,
      invalid = _ref.invalid,
      namespace = _ref.namespace,
      _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? defaultPropObject : _ref$classes,
      isSorting = _ref.isSorting,
      selected = _ref.selected,
      sortingTitle = _ref.sortingTitle,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _getMethodsForTestId = getMethodsForTestId(namespace, 'filterButton'),
      getTestId = _getMethodsForTestId.getTestId;

  var classesMap = {
    common: {
      wrapper: cx('root', {
        active: active,
        block: block,
        completed: completed,
        invalid: invalid
      }, classes.root)
    },
    default: {
      button: cx('button', (_cx = {}, _defineProperty(_cx, "theme_".concat(theme), theme), _defineProperty(_cx, "size_".concat(size), size), _defineProperty(_cx, "block", block), _cx)),
      closeButton: cx('button', _defineProperty({}, "theme_".concat(theme), theme)),
      icon: cx('icon', 'chevron'),
      closeIcon: cx('icon'),
      text: cx('text')
    },
    sorting: {
      button: cx('sort-button'),
      icon: cx('sort-icon'),
      text: cx('text-sort')
    }
  };
  var textSize = isSorting ? 'm' : 'l';
  var title = isSorting ? /*#__PURE__*/React.createElement(React.Fragment, null, sortingTitle, " ", (selected === null || selected === void 0 ? void 0 : selected.label) && "(".concat(selected.label, ")")) : children; // eslint-disable-next-line no-nested-ternary

  var textColor = disabled ? 'N100' : isSorting && !completed ? 'N300' : 'N900';
  return /*#__PURE__*/React.createElement("div", _extends({}, rest, getTestId(), {
    className: classesMap.common.wrapper
  }), /*#__PURE__*/React.createElement("button", _extends({}, buttonProps, getTestId('button'), {
    type: "button",
    className: isSorting ? classesMap.sorting.button : classesMap.default.button,
    onClick: onClick,
    ref: ref,
    disabled: disabled
  }, getTestId('button')), /*#__PURE__*/React.createElement(TextBase, {
    color: textColor,
    size: textSize,
    classes: {
      root: isSorting ? classesMap.sorting.text : classesMap.default.text
    }
  }, title), selected !== null && selected !== void 0 && selected.icon ? /*#__PURE__*/React.createElement("div", {
    className: classesMap.sorting.icon
  }, selected.icon) : !completed && /*#__PURE__*/React.createElement("span", {
    className: classesMap.default.icon
  }, /*#__PURE__*/React.createElement(ChevronNormalDown, {
    color: "N300"
  }))), completed && !isSorting && /*#__PURE__*/React.createElement("button", _extends({}, buttonProps, getTestId('button'), {
    type: "button",
    className: classesMap.default.closeButton,
    onClick: onClear,
    disabled: disabled
  }, getTestId('button')), closable && /*#__PURE__*/React.createElement("span", {
    className: classesMap.default.closeIcon
  }, /*#__PURE__*/React.createElement(CloseSmallLinear, null))));
});
export default FilterButton;